import { useCallback, useState } from 'react';
import VersionTraceModal from '@components/VersionTraceModal';

/**
 * 算法版本追溯 Modal 的页面级接线：把「打开 Modal」的状态与渲染收敛成一处，
 * 供任务列表类页面在 `AlgorithmVersionCell` 上挂 `onTrace`、并在页面尾渲染 `modal`。
 *
 * 用法：
 * ```tsx
 * const { onTrace, modal } = useVersionTrace();
 * // 表格列：<AlgorithmVersionCell ... traceEntryVersion={record.traceEntryVersion} onTrace={onTrace} />
 * // 页面尾：{modal}
 * ```
 *
 * @param zIndex 叠放层级。页面级用法省略即可（antd 默认 1000）；**从另一个 Modal
 *   里打开追溯时必须传更大值**，否则会被那个 Modal 盖住 —— 见
 *   {@link VersionTraceModalProps.zIndex} 的说明。
 */
export function useVersionTrace(zIndex?: number) {
  const [version, setVersion] = useState<string | null>(null);
  const [open, setOpen] = useState(false);

  const onTrace = useCallback((v: string) => {
    setVersion(v);
    setOpen(true);
  }, []);

  const onClose = useCallback(() => setOpen(false), []);

  const modal = (
    <VersionTraceModal open={open} version={version} onClose={onClose} zIndex={zIndex} />
  );

  return { onTrace, modal };
}
